"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateAdminCampaignSummaryCompactDto = exports.CampaignBudgetRecipientPatchDto = exports.AdminCampaignSummaryDisplayPatchDto = exports.AdminCampaignSummaryTotalPatchDto = exports.CampaignDiscountResultPatchDto = exports.RejectedCampaignDiscountPatchDto = exports.AppliedCampaignDiscountPatchDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const types_1 = require("../../types");
class AppliedCampaignDiscountPatchDto {
    ruleId;
    name;
    code;
    type;
    target;
    amount;
    affectedDisplayIds;
    ruleSnapshot;
}
exports.AppliedCampaignDiscountPatchDto = AppliedCampaignDiscountPatchDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], AppliedCampaignDiscountPatchDto.prototype, "ruleId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], AppliedCampaignDiscountPatchDto.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], AppliedCampaignDiscountPatchDto.prototype, "code", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(types_1.DiscountType),
    __metadata("design:type", String)
], AppliedCampaignDiscountPatchDto.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(types_1.DiscountTarget),
    __metadata("design:type", String)
], AppliedCampaignDiscountPatchDto.prototype, "target", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], AppliedCampaignDiscountPatchDto.prototype, "amount", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], AppliedCampaignDiscountPatchDto.prototype, "affectedDisplayIds", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsObject)(),
    __metadata("design:type", Object)
], AppliedCampaignDiscountPatchDto.prototype, "ruleSnapshot", void 0);
class RejectedCampaignDiscountPatchDto {
    ruleId;
    code;
    name;
    reason;
    details;
}
exports.RejectedCampaignDiscountPatchDto = RejectedCampaignDiscountPatchDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RejectedCampaignDiscountPatchDto.prototype, "ruleId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RejectedCampaignDiscountPatchDto.prototype, "code", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RejectedCampaignDiscountPatchDto.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", Object)
], RejectedCampaignDiscountPatchDto.prototype, "reason", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RejectedCampaignDiscountPatchDto.prototype, "details", void 0);
class CampaignDiscountResultPatchDto {
    subtotalBeforeDiscounts;
    discountTotal;
    subtotalAfterDiscounts;
    applied;
    rejected;
    usageCommitId;
    usageCommittedAt;
}
exports.CampaignDiscountResultPatchDto = CampaignDiscountResultPatchDto;
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], CampaignDiscountResultPatchDto.prototype, "subtotalBeforeDiscounts", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], CampaignDiscountResultPatchDto.prototype, "discountTotal", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], CampaignDiscountResultPatchDto.prototype, "subtotalAfterDiscounts", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => AppliedCampaignDiscountPatchDto),
    __metadata("design:type", Array)
], CampaignDiscountResultPatchDto.prototype, "applied", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => RejectedCampaignDiscountPatchDto),
    __metadata("design:type", Array)
], CampaignDiscountResultPatchDto.prototype, "rejected", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CampaignDiscountResultPatchDto.prototype, "usageCommitId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", Object)
], CampaignDiscountResultPatchDto.prototype, "usageCommittedAt", void 0);
class AdminCampaignSummaryTotalPatchDto {
    taxes;
    admefee;
    amount;
    total;
    discount;
    subtotalBeforeDiscounts;
    subtotalAfterDiscounts;
    currency;
}
exports.AdminCampaignSummaryTotalPatchDto = AdminCampaignSummaryTotalPatchDto;
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], AdminCampaignSummaryTotalPatchDto.prototype, "taxes", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], AdminCampaignSummaryTotalPatchDto.prototype, "admefee", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], AdminCampaignSummaryTotalPatchDto.prototype, "amount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], AdminCampaignSummaryTotalPatchDto.prototype, "total", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], AdminCampaignSummaryTotalPatchDto.prototype, "discount", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], AdminCampaignSummaryTotalPatchDto.prototype, "subtotalBeforeDiscounts", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], AdminCampaignSummaryTotalPatchDto.prototype, "subtotalAfterDiscounts", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", Object)
], AdminCampaignSummaryTotalPatchDto.prototype, "currency", void 0);
class AdminCampaignSummaryDisplayPatchDto {
    displayId;
    ownerPercentage;
    amountPerBlock;
    total;
    discounts;
}
exports.AdminCampaignSummaryDisplayPatchDto = AdminCampaignSummaryDisplayPatchDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], AdminCampaignSummaryDisplayPatchDto.prototype, "displayId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(100),
    __metadata("design:type", Number)
], AdminCampaignSummaryDisplayPatchDto.prototype, "ownerPercentage", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], AdminCampaignSummaryDisplayPatchDto.prototype, "amountPerBlock", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => AdminCampaignSummaryTotalPatchDto),
    __metadata("design:type", Array)
], AdminCampaignSummaryDisplayPatchDto.prototype, "total", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => CampaignDiscountResultPatchDto),
    __metadata("design:type", CampaignDiscountResultPatchDto)
], AdminCampaignSummaryDisplayPatchDto.prototype, "discounts", void 0);
class CampaignBudgetRecipientPatchDto {
    companyName;
    taxId;
    address;
    attention;
    email;
    reference;
    validity;
}
exports.CampaignBudgetRecipientPatchDto = CampaignBudgetRecipientPatchDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(200),
    __metadata("design:type", String)
], CampaignBudgetRecipientPatchDto.prototype, "companyName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(40),
    __metadata("design:type", String)
], CampaignBudgetRecipientPatchDto.prototype, "taxId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(300),
    __metadata("design:type", String)
], CampaignBudgetRecipientPatchDto.prototype, "address", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(200),
    __metadata("design:type", String)
], CampaignBudgetRecipientPatchDto.prototype, "attention", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEmail)(),
    (0, class_validator_1.MaxLength)(254),
    __metadata("design:type", String)
], CampaignBudgetRecipientPatchDto.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(120),
    __metadata("design:type", String)
], CampaignBudgetRecipientPatchDto.prototype, "reference", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(60),
    __metadata("design:type", String)
], CampaignBudgetRecipientPatchDto.prototype, "validity", void 0);
class UpdateAdminCampaignSummaryCompactDto {
    revision;
    total;
    displayUpdates;
    budgetRecipient;
}
exports.UpdateAdminCampaignSummaryCompactDto = UpdateAdminCampaignSummaryCompactDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], UpdateAdminCampaignSummaryCompactDto.prototype, "revision", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => AdminCampaignSummaryTotalPatchDto),
    __metadata("design:type", Array)
], UpdateAdminCampaignSummaryCompactDto.prototype, "total", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.ArrayMaxSize)(5_000),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => AdminCampaignSummaryDisplayPatchDto),
    __metadata("design:type", Array)
], UpdateAdminCampaignSummaryCompactDto.prototype, "displayUpdates", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => CampaignBudgetRecipientPatchDto),
    __metadata("design:type", CampaignBudgetRecipientPatchDto)
], UpdateAdminCampaignSummaryCompactDto.prototype, "budgetRecipient", void 0);
